import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import userimage from "../../Assets/images/user.png"
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { encodeID, getDate, timeAgo } from "../../utils/Helper";
import { useSelector } from "react-redux";
import { PAGINATION } from "../../constants/Constants";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import WelcomeMessage from "../../Modal/WelcomeMessage";


function Notification() {
  const notification = useMakeRequest()
  const update = useMakeRequest()
  const navigate = useNavigate()
  const [show, setShow] = useState(false)
  const profiledata = useSelector((state: any) => state?.ProfileState)
  const [pagination, setPagination] = useState<any>({ pageIndex: PAGINATION?.PAGE, pageSize: PAGINATION?.PAGESIZE });
  const [expanded, setExpanded] = useState<any>({}); // Store expanded states per notification

  useEffect(() => {
    const payload = {
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
    }
    notification.makeRequest({ payload, url: ApiConstants?.NotificationList, toastStatus: false })
  }, [pagination , update.status])
  const handleIncreasePageSize = () => {
    setPagination((prevState: any) => ({
      ...prevState,
      pageSize: prevState.pageSize + 10
    }));
  };
  const handelNavigate = (data: any) => {
    const payload ={
      detail_id:data?.id
    }
    if (data?.data_params?.type == 'quotation') {
      navigate(`/view-quotation/${data?.data_params?.id}`)
       update.makeRequest({ payload, url: ApiConstants?.NotificationUpdate, toastStatus: false })
    }
    else if (data?.data_params?.type == 'order') {
      navigate(`/order-detail/${encodeID(data?.data_params?.id)}`)
       update.makeRequest({ payload, url: ApiConstants?.NotificationUpdate, toastStatus: false })
    } else if (data?.data_params?.type == 'Admin') {
      setShow(true)
       update.makeRequest({ payload, url: ApiConstants?.NotificationUpdate, toastStatus: false })
    } else {
       update.makeRequest({ payload, url: ApiConstants?.NotificationUpdate, toastStatus: false })
      return
    }
  }

  const toggleExpand = (index: any) => {
    setExpanded((prev: any) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };



  return (
    <>
      {notification.loading ? <FrontLoader /> : null}
      <main>
        {/* top banner section start */}
        <section
          className="main-banner small-banner"
          style={{ background: `url(${profileBanner}) center/cover` }}
        >
          <div className="container">
            <h1 className="small-banner-heading">{LanguageConstants?.NOTIFACTION}</h1>
          </div>
        </section>
        <div className="footer-space">
          <div className="container">

            <div className="notification-list">
              {notification?.data?.data?.rows.length > 0 ? notification?.data?.data?.rows?.map((res: any, i: any) => {
                const message = res?.notification_params?.body || '';
                const isLong = message.length > 100; // Set your truncation length (e.g., 100 chars)
                const isExpanded = expanded[i];
                return (
                  <div className="notification-single" key={i} onClick={() => handelNavigate(res)} style={{ cursor: 'pointer' }} >
                    <img className="notification-img" src={profiledata?.data?.data?.profile_pic ? profiledata?.data?.data?.profile_pic : userimage} alt="" />
                    <div className="me-auto">
                      {/* <div className="notification-ttl">{res?.notification_params?.title}</div> */}
                      {res?.is_read == '1' ?
                        <div className="notification-ttl"></div>
                        : null}
                      <p className={res?.is_read == '1' ? "notification-para" : 'notification-para fw-bold'}>

                        {isLong && !isExpanded
                          ? message.slice(0, 100) + '...'
                          : message}

                        {isLong && (
                          <span
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent triggering `handelNavigate`
                              toggleExpand(i);
                            }}
                            style={{
                              color: '#5A32C7',
                              cursor: 'pointer',
                              fontSize: '14px',
                              marginLeft: '5px'
                            }}
                          >
                            {isExpanded ? 'Show less' : 'Show more'}
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="notification-time">{getDate(res?.created_at)}</div>
                  </div>
                )
              }) :
                <p className="text-center mt-3">{LanguageConstants?.DATANOTFOUND}</p>
              }
            </div>
            {notification?.data?.data?.count > 10 && notification?.data?.data?.count > pagination.pageSize
              ?
              <button className="round-btn" onClick={() => handleIncreasePageSize()} >{LanguageConstants?.MORE}</button>
              : null}



          </div>
        </div>
      </main>
      {/* show shpinng details start */}
      <Modal show={show}>
        <WelcomeMessage setShow={setShow} />
      </Modal>
      {/* show shpinng details end */}
    </>
  )
}

export default Notification